<template>

  <!--Mobile-->
  <div class="lt-sm">
    <div class="text-075" v-if="term > 1">
      <q-icon name="lock"></q-icon>
      Locked Rate
    </div>
    <!--No Contract-->
    <div class="text-075" style="display: flex; align-items: baseline" v-else>
      <q-icon name="lock_open" class="q-mr-xs"></q-icon>
      No Contract
    </div>
  </div>

  <!--Desktop-->
  <div class="gt-xs">
    <div class="text-0875" v-if="term > 1">
      <q-icon name="lock"></q-icon>
      Locked Rate
    </div>
    <!--No Contract-->
    <div class="text-0875" style="display: flex; align-items: baseline" v-else>
      <q-icon name="lock_open" class="q-mr-xs"></q-icon>
      No Contract
    </div>
  </div>

</template>

<script>
export default {
  name: "PlanType",
  props: {
    term: {
      type: Number
    }
  }
}
</script>

<style scoped>

</style>